(function (): void {
    function handleNavigation(): void {
        const isHamburger: boolean = window.innerWidth < 992;
        const desktopElements: NodeListOf<Element> = document.querySelectorAll('.desktop-nav');
        const mobileElements: NodeListOf<Element> = document.querySelectorAll('.mobile-nav');

        if (isHamburger) {
            desktopElements.forEach((el: Element) => {
                (el as HTMLElement).style.display = 'none';
            });
            mobileElements.forEach((el: Element) => {
                (el as HTMLElement).style.display = 'block';
            });
        } else {
            desktopElements.forEach((el: Element) => {
                (el as HTMLElement).style.display = '';
            });
            mobileElements.forEach((el: Element) => {
                (el as HTMLElement).style.display = 'none';
            });
        }
    }

    handleNavigation();
    window.addEventListener('resize', handleNavigation);
})();